import React, { useRef } from "react";
import styled from "styled-components";

import { Svg } from "./Svg";
import { mdiUpload } from "@mdi/js";

const FileSelectStyle = styled.div`
    white-space: nowrap;
    button {
        width: 100%;
        border: none;
        display: flex;
        cursor: pointer;
        border-radius: 2px;
        padding: 6px 12px 5px 12px;
        color: ${props => props.theme.white};
        transition: background-color 0.3s, color 0.3s;
        background-color: ${props => props.theme.primaryLight};
        &:hover {
            background-color: ${props => props.theme.primaryLighter};
        }
        &:disabled {
            background-color: ${props => props.theme.greyLight};
        }
        >svg {
            margin-right: 6px;
        }
    }
    input {
        display: none;
    }
`;

export const FileSelect = props => {

    const { value, disabled, loading, accept, multiple } = props;
    const fileInput = useRef(null);

    const onClick = async () => {
        if (props.onClick) {
            const result = await props.onClick();
            if (result === false) {
                return;
            }
        }
        fileInput.current.click();
    };

    const onSelect = event => {
        props.onSelect(event);
        event.target.value = null;
    };

    return (
        <FileSelectStyle>
            <button
                onClick={onClick}
                disabled={disabled || loading}>
                <Svg path={mdiUpload} size="16" loading={loading} />
                {value}
            </button>
            <input
                multiple={multiple ?? false}
                type="file"
                ref={fileInput}
                accept={accept}
                onChange={onSelect} />
        </FileSelectStyle>
    );
};